import { normalizeToPhoneE164 } from "../phone";
import type { ConversationId } from "./conversation-id";
import { ConversationIdSchema } from "./conversation-id";
import type { PhoneE164 } from "./phone-e164";

/**
 * Convert a PhoneE164 to ConversationId
 * In this app, conversation IDs align with the canonical PhoneE164 identity.
 */
export function phoneE164ToConversationId(phone: PhoneE164): ConversationId {
	return ConversationIdSchema.parse(phone);
}

/**
 * Try to convert a string to ConversationId via PhoneE164 normalization
 * Returns null if the input cannot be normalized or does not match ConversationId requirements
 */
export function tryNormalizeToConversationId(
	id: string
): ConversationId | null {
	try {
		const normalized = normalizeToPhoneE164(id);
		return ConversationIdSchema.parse(normalized);
	} catch {
		return null;
	}
}
